import { forwardRef } from 'react';
import type { SVGProps, Ref } from 'react';
type Props = SVGProps<SVGSVGElement>;
/**
 * @public
 */

const SvgSave = forwardRef((props: Props, svgRef: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1.5em"
    height="1.5em"
    fill="none"
    viewBox="0 0 24 24"
    ref={svgRef}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.52 7.727h6.778c.135 0 .244.003.244.146v8.23c0 .142-.11.257-.244.257h-2.892c-.403 0-.73.347-.73.775 0 .428.327.774.73.774h2.892c.94 0 1.702-.809 1.702-1.807v-8.23c0-.997-.762-1.807-1.702-1.807h-6.482L10.025 4.22A.708.708 0 009.517 4H5.702C4.762 4 4 4.81 4 5.807v10.295c0 .998.762 1.808 1.702 1.808H9.09c.402 0 .729-.347.729-.775 0-.428-.327-.775-.73-.775H5.703a.25.25 0 01-.244-.258V7.727h6.063zm.095 11.523a.75.75 0 001.5 0v-6.346l1.36 1.283a.719.719 0 00.986-1.045l-2.544-2.401a.717.717 0 00-.561-.193.718.718 0 00-.561.193L9.25 13.142a.719.719 0 10.986 1.045l1.378-1.3v6.363z"
      clipRule="evenodd"
    />
  </svg>
));
SvgSave.defaultProps = {
  'aria-hidden': true,
  focusable: 'false',
  role: 'img',
};
export default SvgSave;
